(function() { window.GUID_fd64cf7d_673e_42e4_8001_06bf6f4f7f30 = { getGuid: function() { return "fd64cf7d-673e-42e4-8001-06bf6f4f7f30"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class ScriptErrorLogger {
            constructor() { }
            static get Instance() {
                if (!ScriptErrorLogger.instance) {
                    ScriptErrorLogger.instance = new ScriptErrorLogger();
                }
                return ScriptErrorLogger.instance;
            }
            static DisplayError(props) {
                const errorMessage = props.file ? `Message: ${props.message} (File: ${props.file})` : `Message: ${props.message}`;
                ScriptErrorLogger.Instance.showAndSaveErrors(errorMessage);
            }
            LogError() {
                try {
                    // handled errors
                    // const originalConsoleError = console.error;
                    // console.error = (...data: any[]) => {
                    //   originalConsoleError(...data);
                    //   let errorMessage =
                    //     "Handled script error in a 'try catch' : " + data[0];
                    //   if (
                    //     !errorMessage.includes(
                    //       "Standalone bad response. Status; 400 Response:"
                    //       ) && !errorMessage.includes(
                    //           "Ezoic"
                    //       )
                    //   ) {
                    //     this.showAndSaveErrors(errorMessage);
                    //   }
                    // };
                    // unhandled errors
                    window.onerror = (msg) => {
                        let errorMessage = "Unhandled script error : " + msg;
                        this.showAndSaveErrors(errorMessage);
                    };
                }
                catch (error) {
                    console.error("Error while binding to ScriptErrorLogger", error);
                }
            }
            showAndSaveErrors(errorMessage) {
                const buffer = 1;
                if (!ScriptErrorStatic.Instance.errors.find((index) => index == errorMessage))
                    ScriptErrorStatic.Instance.errors.push(errorMessage);
                let $scriptError = $("#scriptError");
                if ($scriptError.length == 0) {
                    $("#section-middle").append(`<div id="scriptError"></div>`);
                    $scriptError = $("#scriptError");
                    $scriptError.css({
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        zIndex: 9999,
                        backgroundColor: "red",
                        color: "black",
                        fontSize: "80%",
                    });
                    $scriptError.offon("click.removeErrorMessage", ".script-error-message", function () {
                        try {
                            $(this).remove();
                        }
                        catch (error) {
                            console.error("Error while removing script error message", error);
                        }
                    });
                }
                let divErrorsCount = $(".script-error-message", $scriptError).length;
                if (divErrorsCount < buffer) {
                    $scriptError[0].innerHTML += `<div class="script-error-message" >${errorMessage} </div>`;
                }
                if ($('#numberOfScriptError').length == 0)
                    $('#scriptError').append(`<div id="numberOfScriptError"></div>`);
                $('#numberOfScriptError')[0].innerHTML = `<div class="script-error-message" >Number of different errors : ${ScriptErrorStatic.Instance.errors.length} </div>`;
            }
        }
        Controls.ScriptErrorLogger = ScriptErrorLogger;
        class ScriptErrorStatic {
            static get Instance() {
                if (!ScriptErrorStatic.instance) {
                    ScriptErrorStatic.instance = new ScriptErrorStatic();
                }
                return ScriptErrorStatic.instance;
            }
            constructor() {
                this.errors = [];
            }
        }
        Controls.ScriptErrorStatic = ScriptErrorStatic;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=ScriptErrorLogger.js.map
